export default __webpack_public_path__ + "static/blog-0-01-791d4300954193bc941c75b523f4e845.png";